import { CartLinesQueryResult } from '@graphql/queries/__generated__/cart.generated'
import React, { useMemo } from 'react'
import FormattedPrice from '@components/FormattedPrice'

interface CartLinePriceProps {
  line?: CartLinesQueryResult['data']['cartLines']['results'][0]
  part?: CartLinesQueryResult['data']['cartLines']['results'][0]['supplyParts'][0]
  qty: number
}

const CartLinePrice: React.FC<CartLinePriceProps> = ({ line, qty, part }) => {
  const linePrice = useMemo<{ undiscount: number; discount: number; currency: string } | null>(() => {
    if (line) {
      if (!line.supplyParts.length) {
        return {
          currency: line.variant.wholesalePrice.currency,
          undiscount: line.variant.wholesalePrice.undiscount,
          discount: line.variant.wholesalePrice.discount,
        }
      } else {
        return line.supplyParts.reduce(
          (prev, curr) => {
            return {
              currency: curr.variant.wholesalePrice.currency,
              undiscount: prev.undiscount + curr.variant.wholesalePrice.undiscount * curr.quantity,
              discount: prev.discount + curr.variant.wholesalePrice.discount * curr.quantity,
            }
          },
          { currency: '', undiscount: 0, discount: 0 }
        )
      }
    }
    if (part) {
      return {
        currency: part.variant.wholesalePrice.currency,
        undiscount: part.variant.wholesalePrice.undiscount,
        discount: part.variant.wholesalePrice.discount,
      }
    }
    return null
  }, [line, part])

  if (!linePrice) return null
  const isSale = linePrice.discount !== linePrice.undiscount

  return (
    <>
      <span className={isSale ? 'line-through' : ''}>
        <FormattedPrice amount={linePrice.undiscount * qty} currency={linePrice.currency} />
      </span>
      {isSale && (
        <span className={`text-red`}>
          {' '}
          <FormattedPrice amount={linePrice.discount * qty} currency={linePrice.currency} />
        </span>
      )}
    </>
  )
}

export default CartLinePrice
